import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["businessAccountId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import axios from 'axios';
import { omitBy, isNil } from 'lodash';
import { getLocale } from 'libs/utils/window';
import { EntryType } from 'constants/photo-tip';
import { API_BASE_PATH } from 'constants/paths';
import ApiClient, { interceptors } from 'libs/common/api-client';
import * as requests from './requests';
import * as transformers from './transformers/args';
const moneyObjectHeader = {
  'X-Money-Object': 'true'
};
const baseURL = API_BASE_PATH;
const api = new ApiClient({
  baseURL
}, [interceptors.csrfTokenInterceptor, interceptors.errorInterceptor, interceptors.tokenRefreshInterceptor, interceptors.localeInterceptor, interceptors.phoneVerificationInterceptor, interceptors.twoFAInterceptor, interceptors.anonIdInterceptor]);
export const requestColors = () => api.get('/colors');
export const getCatalogs = requests.getCatalogsRequest(api);
export const getDiscoveryCatalogs = requests.getDiscoveryCatalogsRequest(api);
export const getSizeGroups = () => api.get('/size_groups');
export const getVideoGameRatings = () => api.get('/video_game_ratings');
export const removeReservation = itemId => api.delete("/items/".concat(itemId, "/reservation"));
export const getItemUploadConfiguration = () => api.get('/items/configuration');
export const completeItem = (itemId, draft, feedbackId) => api.post("items/drafts/".concat(itemId, "/completion"), {
  draft,
  feedback_id: feedbackId
}, {
  headers: moneyObjectHeader
});
export const createItemDraft = (draft, feedbackId) => api.post('/items/drafts', {
  draft,
  feedback_id: feedbackId
}, {
  headers: moneyObjectHeader
});
export const confirmComplaintResolved = conversationId => api.patch("/conversations/".concat(conversationId, "/complaint/confirm_resolved"));
export const declineComplaintResolved = conversationId => api.patch("/conversations/".concat(conversationId, "/complaint/refuse_resolved"));
export const updateItemDraft = (draftId, draft, feedbackId) => api.put("/items/drafts/".concat(draftId), {
  draft,
  feedback_id: feedbackId
}, {
  headers: moneyObjectHeader
});
export const deleteItem = id => api.post("/items/".concat(id, "/delete"));
export const deleteItemDraft = id => api.delete("/items/drafts/".concat(id));
export const getItemAuthenticityModal = function (catalogId, itemId) {
  let force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return api.get('/items/authenticity_modals', {
    params: {
      catalog_id: catalogId,
      force,
      item_id: itemId
    }
  });
};
export const getConfiguration = () => api.get('/configuration');
export const getSystemConfiguration = requests.getSystemConfigurationRequest(api);
export const updateItem = (itemId, item, feedbackId) => api.put("/items/".concat(itemId), {
  item,
  feedback_id: feedbackId
}, {
  headers: moneyObjectHeader
});
export const modifyItemVisibility = (itemId, isHidden) => api.put("/items/".concat(itemId, "/is_hidden"), {
  is_hidden: isHidden
});
export const createItem = (item, feedbackId) => api.post('/items', {
  item,
  feedback_id: feedbackId
}, {
  headers: moneyObjectHeader
});
export const getCatalogItems = args => api.get('/catalog/items', {
  params: transformers.getCatalogItemsArgsToParams(args),
  headers: moneyObjectHeader
});
export const getCatalogInitializers = args => api.get('/catalog/initializers', {
  params: omitBy(args, isNil),
  headers: moneyObjectHeader
});
export const getCatalogFilters = args => api.get('/catalog/filters', {
  params: transformers.getCatalogFiltersArgsToParams(args)
});
export const getCatalogDefaultFilters = args => api.get('/catalog/filters/defaults', {
  params: transformers.getCatalogDefaultFiltersArgsToParams(args)
});
export const getCatalogSearchedFilters = args => api.get('/catalog/filters/search', {
  params: transformers.getCatalogSearchedFiltersArgsToParams(args)
});
export const getPhotoTips = function () {
  let entryType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EntryType.Default;
  return api.get('/photo_tips', {
    params: {
      entry_type: entryType
    }
  });
};
export const getPhotoTip = id => api.get("/photo_tips/".concat(id));
export const getCountries = () => api.get('/countries');
export const getCountriesSelection = () => api.get('/country_selection');
export const searchCities = _ref => {
  let {
    countryId,
    searchText
  } = _ref;
  return api.get("/countries/".concat(countryId, "/cities"), {
    params: {
      search_text: searchText || ''
    }
  });
};
export const getBrands = _ref2 => {
  let {
    keyword,
    includeAllBrands
  } = _ref2;
  return api.get('/brands', {
    params: omitBy({
      keyword,
      all_brands: includeAllBrands || null
    }, isNil)
  });
};
export const getPopularBrands = function () {
  let {
    letter
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return api.get('/brands/popular', {
    params: {
      letter
    }
  });
};
export const getBrandById = brandId => api.get("/brands/".concat(brandId));
export const getBrandsFollowedByUser = userId => api.get("/users/".concat(userId, "/brands"));
export const sendHelpCenterFeedback = args => api.post('/help_center/feedbacks', transformers.sendHelpCenterFeedbackArgsToParams(args));
export const getShowItemUploadFeedback = () => api.get('/items/show_upload_feedback');
export const getItemUploadFeedbackRatings = () => api.get('/items/upload_feedback');
export const sendItemUploadFeedback = args => api.put('/items/upload_feedback', transformers.sendItemUploadFeedbackArgsToParams(args));
export const sendNpsSurveyResponse = _ref3 => {
  let {
    userId,
    score,
    comment,
    incomplete
  } = _ref3;
  return api.post("/users/".concat(userId, "/nps"), {
    score,
    comment,
    incomplete
  });
};
export const completeTransaction = id => api.put("/transactions/".concat(id, "/complete"), undefined, {
  headers: moneyObjectHeader
});
export const deleteUser = (userId, notes) => api.delete("/users/".concat(userId), {
  params: {
    delete_account_notes: notes
  }
});
export const getUserById = _ref4 => {
  let {
    id,
    localize = false
  } = _ref4;
  return api.get("/users/".concat(id), {
    params: {
      localize
    }
  });
};
export const getFeedEvents = (itemCount, fetchesCount, maxScore) => api.get('/feed/events', {
  params: {
    max_score: maxScore,
    item_count: itemCount,
    fetch_count: fetchesCount
  }
});
export const getHomepageBlocks = function () {
  let version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return api.get('/homepage_blocks', {
    params: {
      version
    }
  });
};
export const prepareClosetPromotionOrder = () => api.post('/promoted_closets/orders/prepare', undefined, {
  headers: moneyObjectHeader
});
export const getClosetPromotions = args => api.get('/promoted_closets', {
  params: transformers.getClosetPromotionsArgsToParams(args),
  headers: moneyObjectHeader
});
export const sendPromotedClosetFeedback = args => api.post('/promoted_closets/feedback', args);
export const getUserItems = args => api.get("/users/".concat(args.userId, "/items"), {
  params: transformers.getUserItemsArgsToParams(args),
  headers: moneyObjectHeader
});
export const getUserBundleItems = _ref5 => {
  let {
    userId,
    selectedItemId,
    currentPage,
    perPage
  } = _ref5;
  return api.get("/users/".concat(userId, "/bundle_items"), {
    params: {
      page: currentPage + 1,
      per_page: perPage,
      selected_item_id: selectedItemId
    },
    headers: moneyObjectHeader
  });
};
export const createBundleSummary = _ref6 => {
  let {
    itemIds,
    sellerId
  } = _ref6;
  return api.post('/bundle_summary', {
    item_ids: itemIds,
    seller_id: sellerId
  });
};
export const getBundleOrderReview = _ref7 => {
  let {
    itemIds,
    sellerId
  } = _ref7;
  return api.post('/bundle_order_review', {
    item_ids: itemIds,
    seller_id: sellerId
  });
};
export const createBundleTransaction = _ref8 => {
  let {
    selectedItemIds,
    bundleTrackingId,
    bundleShippingType
  } = _ref8;
  return api.post('/bundles', {
    item_ids: selectedItemIds,
    bundle_id: bundleTrackingId,
    bundle_shipping_type: bundleShippingType
  }, {
    headers: moneyObjectHeader
  });
};
export const editBundleTransaction = _ref9 => {
  let {
    transactionId,
    selectedItemIds,
    bundleTrackingId,
    bundleShippingType
  } = _ref9;
  return api.put("/transactions/".concat(transactionId, "/bundle"), {
    item_ids: selectedItemIds,
    bundle_id: bundleTrackingId,
    bundle_shipping_type: bundleShippingType
  }, {
    headers: moneyObjectHeader
  });
};
export const updateUserBundleDiscounts = args => api.put("/users/".concat(args.userId, "/multitier_bundle_discount"), transformers.updateUserBundleDiscountsArgsToParams(args));
export const getSortedSavedSearches = userId => api.get("/users/".concat(userId, "/searches/sorted"), {
  headers: moneyObjectHeader
});
export const getSavedSearch = _ref10 => {
  let {
    userId,
    id
  } = _ref10;
  return api.get("/users/".concat(userId, "/searches/").concat(id), {
    headers: moneyObjectHeader
  });
};
export const createSavedSearch = _ref11 => {
  let {
    userId,
    search
  } = _ref11;
  return api.post("/users/".concat(userId, "/searches"), {
    search
  }, {
    headers: moneyObjectHeader
  });
};
export const updateSavedSearch = _ref12 => {
  let {
    id,
    userId,
    search,
    keepLastVisitTime
  } = _ref12;
  return api.put("/users/".concat(userId, "/searches/").concat(id), {
    search,
    keep_last_visit_time: !!keepLastVisitTime
  }, {
    headers: moneyObjectHeader
  });
};
export const getSearchSuggestions = _ref13 => {
  let {
    query
  } = _ref13;
  return api.get('/search_suggestions', {
    params: {
      query
    }
  });
};
export const getInboxConversations = _ref14 => {
  let {
    currentPage,
    perPage
  } = _ref14;
  return api.get('/inbox', {
    params: omitBy({
      page: currentPage,
      per_page: perPage
    }, isNil)
  });
};
export const getInboxListItem = _ref15 => {
  let {
    conversationId
  } = _ref15;
  return api.get("/inbox/".concat(conversationId));
};
export const setConversationAsRead = _ref16 => {
  let {
    conversationId
  } = _ref16;
  return api.put("/conversations/".concat(conversationId, "/mark_as_read"));
};
export const translateConversation = _ref17 => {
  let {
    conversationId,
    translate
  } = _ref17;
  return api.put("/conversations/".concat(conversationId, "/translation"), {
    translate
  });
};
export const getTip = (userId, tipType) => api.get("/users/".concat(userId, "/tip"), {
  params: {
    type: tipType
  }
});
export const getBanners = () => api.get('/banners');
export const getItem = args => api.get("/items/".concat(args.id), {
  params: {
    localize: args.localize || false
  },
  headers: moneyObjectHeader
});
export const getItemEdit = args => api.get("/item_edits/".concat(args.id));
export const getPackageSizes = _ref18 => {
  let {
    catalogId,
    brandId,
    price
  } = _ref18;
  return api.post('/package_sizes', {
    item_attributes: {
      brand_id: brandId,
      catalog_id: catalogId,
      price
    }
  });
};
export const getCustomShipmentConfig = () => api.get('/configurations/custom_shipment', {
  headers: moneyObjectHeader
});
export const getTransactionPackageSizes = _ref19 => {
  let {
    transactionId
  } = _ref19;
  return api.get("/transactions/".concat(transactionId, "/package_sizes"));
};
export const selectTransactionPackageSize = _ref20 => {
  let {
    transactionId,
    packageSizeId,
    customShipmentPrice
  } = _ref20;
  return api.put("/transactions/".concat(transactionId, "/package_size"), {
    package_size_id: packageSizeId,
    custom_shipment_price: customShipmentPrice
  });
};
export const getLanguages = requests.getLanguagesRequest(api);
export const getCountryLanguages = countryId => api.get("countries/".concat(countryId, "/languages"));
export async function updateLocale(targetLocale) {
  const client = axios.create();
  interceptors.csrfTokenInterceptor(client);
  interceptors.tokenRefreshInterceptor(client);
  const locale = targetLocale || getLocale();

  try {
    return await client.put('/session_locale', {
      locale
    });
  } catch (exception) {
    return null;
  }
}
export const sortItems = itemPositions => api.put('/item_positions', {
  item_positions: itemPositions
});
export const postReply = _ref21 => {
  let {
    conversationId,
    body,
    photoTempUuids
  } = _ref21;
  return api.post("conversations/".concat(conversationId, "/replies"), {
    reply: {
      body,
      photo_temp_uuids: photoTempUuids
    }
  });
};
export const createConversationThread = _ref22 => {
  let {
    recipientId,
    photoTempUuids,
    itemId
  } = _ref22;
  return api.post('/conversations', {
    opposite_user_id: recipientId,
    photo_temp_uuids: photoTempUuids,
    item_id: itemId
  });
};
export const createItemConversationThread = _ref23 => {
  let {
    itemId,
    initiator,
    receiverId
  } = _ref23;
  return api.post('/conversations', {
    initiator,
    item_id: itemId,
    opposite_user_id: receiverId
  });
};
export const toggleUserFavourite = _ref24 => {
  let {
    type,
    entityId
  } = _ref24;
  return api.post('/user_favourites/toggle', {
    type,
    user_favourites: [entityId]
  });
};
export const getFaqEntries = () => api.get('/faq_entries');
export const getFaqNotLoggedInEntries = () => api.get('/faq_entries/not_logged_in');
export const getFaqEntryByType = requests.getFaqEntryByCodeRequest(api);
export const getFaqEntryById = requests.getFaqEntryByIdRequest(api);
export const searchFaqEntries = requests.getFaqEntriesSearchRequest(api);
export const getFaqEntryRecommendedFaqs = (faqId, accessChannel, locale) => api.get("faq_entries/".concat(faqId, "/recommended_faqs?access_channel=").concat(accessChannel).concat(locale ? "&locale=".concat(locale) : ''));
export const getFaqEntryRelatedFaqs = (faqId, accessChannel, locale) => api.get("faq_entries/".concat(faqId, "/related_faqs?access_channel=").concat(accessChannel).concat(locale ? "&locale=".concat(locale) : ''));
export const getInfoBox = () => api.get('faq_entries/faq_infobox');
export const requestEmailChange = userId => api.put("/users/".concat(userId, "/request_email_change"));
export const getUserFeedback = _ref25 => {
  let {
    userId,
    filter,
    page,
    perPage,
    feedbackFilterType
  } = _ref25;
  return api.get('/user_feedbacks', {
    params: omitBy({
      user_id: userId,
      filter,
      page,
      per_page: perPage,
      by: feedbackFilterType
    }, isNil)
  });
};
export const deleteFeedback = _ref26 => {
  let {
    feedbackId
  } = _ref26;
  return api.delete("/user_feedbacks/".concat(feedbackId));
};
export const editFeedbackComment = _ref27 => {
  let {
    feedbackId,
    comment
  } = _ref27;
  return api.put("/user_feedbacks/".concat(feedbackId, "/comment"), {
    comment
  });
};
export const deleteFeedbackComment = _ref28 => {
  let {
    feedbackId
  } = _ref28;
  return api.put("/user_feedbacks/".concat(feedbackId, "/comment"), {
    comment: null
  });
};
export const getFeedback = _ref29 => {
  let {
    feedbackId,
    localize
  } = _ref29;
  return api.get("/user_feedbacks/".concat(feedbackId), {
    params: {
      localize
    }
  });
};
export const createUserFeedback = _ref30 => {
  let {
    userId,
    feedback,
    rating,
    transactionId
  } = _ref30;
  return api.post('/user_feedbacks', {
    user_id: userId,
    feedback,
    rating,
    transaction_id: transactionId
  });
};
export const editUserFeedback = _ref31 => {
  let {
    feedbackId,
    feedback,
    rating,
    feedbackRate
  } = _ref31;
  return api.patch("/user_feedbacks/".concat(feedbackId), {
    feedback,
    rating,
    feedback_rate: feedbackRate
  });
};
export const changeEmail = _ref32 => {
  let {
    id,
    email,
    code,
    fingerprint
  } = _ref32;
  return api.put("/users/".concat(id, "/save_email"), {
    email,
    code,
    fingerprint
  });
};
export const getUserNotifications = _ref33 => {
  let {
    page,
    perPage
  } = _ref33;
  return api.get('/notifications', {
    params: {
      page,
      per_page: perPage
    }
  });
};
export const sendTwoFactorCode = _ref34 => {
  let {
    userId,
    id,
    code,
    fingerprint
  } = _ref34;
  return api.put("/users/".concat(userId, "/user_2fa/").concat(id), {
    code,
    fingerprint
  });
};
export const getItemTitleSuggestions = _ref35 => {
  let {
    brandId,
    statusId,
    catalogId,
    colorId,
    sizeId
  } = _ref35;
  return api.post('/item_title_suggestions', {
    brand_id: brandId,
    status_id: statusId,
    catalog_id: catalogId,
    color_id: colorId,
    size_id: sizeId
  });
};
export const resendTwoFactorCode = _ref36 => {
  let {
    userId,
    id,
    code,
    fingerprint
  } = _ref36;
  return api.post("/users/".concat(userId, "/user_2fa/").concat(id, "/resend"), {
    code,
    fingerprint
  });
};
export const resendLoginTwoFactorCode = _ref37 => {
  let {
    controlCode,
    code,
    fingerprint
  } = _ref37;
  return api.post("/user_login_2fa/".concat(controlCode, "/resend"), {
    code,
    fingerprint
  });
};
export const getPhotos = _ref38 => {
  let {
    type,
    photoEntryId,
    tempUuid
  } = _ref38;
  return api.get('/photos', {
    params: {
      type,
      photo_entry_id: photoEntryId,
      temp_uuid: tempUuid
    }
  });
};
export const createPhoto = photo => api.post('/photos', photo);
export const setBannerAsSeen = _ref39 => {
  let {
    type,
    name
  } = _ref39;
  return api.put("/banners/".concat(type, "/seen"), {
    name
  });
};
export const changeExistingEmail = _ref40 => {
  let {
    email,
    userId
  } = _ref40;
  return api.put("/users/".concat(userId, "/change_email"), {
    email
  });
};
export const getCreditCards = () => api.get('/payments/credit_cards');
export const getCreditCard = _ref41 => {
  let {
    cardId
  } = _ref41;
  return api.get("/payments/credit_cards/".concat(cardId));
};
export const deleteCreditCard = _ref42 => {
  let {
    cardId
  } = _ref42;
  return api.delete("/payments/credit_cards/".concat(cardId));
};
export const deletePhotoSuspicion = photoId => api.delete("/user_msg_photos/".concat(photoId, "/suspicion"));
export const getCheckoutConfiguration = () => api.get('/configurations/checkout');
export const getFavouriteItems = _ref43 => {
  let {
    page,
    perPage,
    userId,
    includeSold
  } = _ref43;
  return api.get("/users/".concat(userId, "/items/favourites"), {
    params: {
      page,
      include_sold: includeSold,
      per_page: perPage
    },
    headers: moneyObjectHeader
  });
};
export const getHomepageBlock = params => api.get('homepage/block', {
  params
});
export const getHomepageShuffleCardSuggestions = _ref44 => {
  let {
    cardId,
    blockName
  } = _ref44;
  return api.get('homepage/shuffle_card', {
    params: {
      card_id: cardId,
      block_name: blockName
    }
  });
};
export const getRecommendedItems = _ref45 => {
  let {
    page,
    perPage,
    userId,
    nextPageToken
  } = _ref45;
  return api.get("/users/".concat(userId, "/items/recommended_items"), {
    params: {
      page,
      per_page: perPage,
      next_page_token: nextPageToken
    }
  });
};
export const updateCurrentUserRealName = _ref46 => {
  let {
    realName,
    target
  } = _ref46;
  return api.put('/users/real_name', {
    user: {
      real_name: realName
    },
    target
  });
};
export const getItemOfflineVerificationEligibility = _ref47 => {
  let {
    brandId,
    price,
    catalogId
  } = _ref47;
  return api.post('/offline_verification/eligibility_check', {
    brand_id: brandId,
    catalog_id: catalogId,
    price
  });
};
export const getIsSecondDayLister = () => api.get('/tracker_attributes', {
  params: {
    type: 'second_day_lister'
  }
});
export const getIsPreviousLister = () => api.get('/tracker_attributes', {
  params: {
    type: 'previous_lister'
  }
});
export const getItemPriceSuggestions = _ref48 => {
  let {
    brandId,
    statusId,
    catalogId
  } = _ref48;
  return api.get('/item_price_suggestions', {
    params: {
      brand_id: brandId,
      status_id: statusId,
      catalog_id: catalogId
    }
  });
};
export const getPushUpOptions = _ref49 => {
  let {
    itemIds
  } = _ref49;
  return api.get('/push_ups/options', {
    params: {
      item_ids: itemIds
    },
    headers: moneyObjectHeader
  });
};
export const preparePushUpOrder = (itemIds, effectiveDays, international) => api.post('/push_ups/orders', {
  item_ids: itemIds,
  effective_days: effectiveDays,
  international
}, {
  headers: moneyObjectHeader
});
export const getPushUpOrder = orderId => api.get("push_ups/orders/".concat(orderId));
export const getPushUpMinimumPrice = _ref50 => {
  let {
    itemPrice
  } = _ref50;
  return api.get('/push_ups/minimum_price', {
    params: {
      item_price: itemPrice
    },
    headers: moneyObjectHeader
  });
};
export const getUserSizes = () => api.get('/user_sizes');
export const updateUserSizes = sizeIds => api.post('/user_sizes', {
  size_ids: sizeIds
});
export const getSimilarSoldItems = _ref51 => {
  let {
    brandId,
    statusId,
    catalogId
  } = _ref51;
  return api.get('/items/similar_sold_items', {
    params: {
      brand_id: brandId,
      status_id: statusId,
      catalog_id: catalogId
    },
    headers: moneyObjectHeader
  });
};
export const getSimilarItems = _ref52 => {
  let {
    brandId,
    statusId,
    catalogId,
    photoId
  } = _ref52;
  return api.get('/item_upload/similar_items', {
    params: {
      brand_id: brandId,
      status_id: statusId,
      catalog_id: catalogId,
      temp_photo_id: photoId
    },
    headers: moneyObjectHeader
  });
};
export const getTransaction = _ref53 => {
  let {
    id
  } = _ref53;
  return api.get("/transactions/".concat(id), {
    headers: moneyObjectHeader
  });
};
export const getCheckoutData = transactionId => api.get("/transactions/".concat(transactionId, "/checkout"), {
  headers: moneyObjectHeader
});
export const updateCheckoutData = (transactionId, args) => api.put("/transactions/".concat(transactionId, "/checkout"), args && transformers.updateCheckoutDataArgsToParams(args), {
  headers: moneyObjectHeader
});
export const initiateSingleCheckout = _ref54 => {
  let {
    id,
    type
  } = _ref54;
  return api.post('/checkout/build', {
    purchase_items: [{
      id: Number(id),
      type
    }]
  });
};
export const updateSingleCheckoutData = (id, args) => api.put("/checkout/".concat(id), args && transformers.updateSingleCheckoutDataArgsToParams(args));
export const getEscrowPayment = transactionId => api.get("/transactions/".concat(transactionId, "/checkout/payment"));
export const initiateEscrowPayment = (transactionId, args) => api.post("/transactions/".concat(transactionId, "/checkout/payment"), transformers.escrowPaymentInitiationArgsToParams(args));
export const updateEscrowPaymentData = (transactionId, args) => api.put("/transactions/".concat(transactionId, "/checkout/payment"), transformers.escrowPaymentDataUpdateArgsToParams(args));
export const getBookDetails = _ref55 => {
  let {
    isbn
  } = _ref55;
  return api.get('/book_details', {
    params: {
      isbn
    }
  });
};
export const resolveComplaint = id => api.post("/complaints/".concat(id, "/resolve"));
export const getUserItemFacets = _ref56 => {
  let {
    userId
  } = _ref56;
  return api.get("/users/".concat(userId, "/item_facets"));
};
export const reuploadItem = id => api.post("/transactions/".concat(id, "/reupload"));
export const confirmCancellationAgreement = transactionId => api.post("/transactions/".concat(transactionId, "/cancellation_agreement/confirm"));
export const declineCancellationAgreement = transactionId => api.post("/transactions/".concat(transactionId, "/cancellation_agreement/decline"));
export const markAsDelivered = transactionId => api.put("/transactions/".concat(transactionId, "/shipment/mark_as_delivered"));
export const getOfflineVerificationFeedback = transactionId => api.get("/transactions/".concat(transactionId, "/verification_feedbacks"));
export const sendOfflineVerificationFeedback = args => api.put("/transactions/".concat(args.transactionId, "/verification_feedbacks"), transformers.sendOfflineVerificationFeedbackArgsToParams(args));
export const getCreditCardConfiguration = () => api.get('/credit_card_configuration');
export const getCurrentUser = requests.getCurrentUserRequest(api);
export const updateCurrentUser = args => api.put('/users/current', transformers.updateCurrentUserArgsToParams(args));
export const updateCurrentUserSettings = args => api.put('/users/current', {
  user: {
    user_settings: transformers.updateCurrentUserSettingsArgsToParams(args)
  }
});
export const updateBusinessAccountProfileDetails = args => api.put("/business_accounts/".concat(args.businessAccountId, "/profile"), transformers.updateBusinessAccountProfileDetailsArgsToParams(args));
export const updateBusinessAccountRepresentativeDetails = _ref57 => {
  let {
    identityDocumentExpirationDate,
    email
  } = _ref57;
  return api.put('/business_accounts_dsa/representatives', {
    identity_document_expiration_date: identityDocumentExpirationDate,
    email
  });
};
export const markAsShipped = _ref58 => {
  let {
    transactionId,
    proofPhotoUuid
  } = _ref58;
  return api.put("/transactions/".concat(transactionId, "/shipment/mark_as_shipped"), {
    proof_photo_uuid: proofPhotoUuid
  });
};
export const partiesHaveMet = transactionId => api.put("/transactions/".concat(transactionId, "/shipment/parties_have_met"));
export const claimCompensation = transactionId => api.put("/transactions/".concat(transactionId, "/claim_compensation"), undefined, {
  headers: moneyObjectHeader
});
export const getCities = args => api.get('/countries/cities', {
  params: {
    country_id: args.countryId,
    search_text: args.searchText
  }
});
export const getPopularCities = countryId => api.get('/popular_cities', {
  params: {
    country_id: countryId
  }
});
export const getPaymentsIdentityFormConfiguration = () => api.get('/payments/identity/edit');
export const getBusinessAccountsTermsOfUseContent = () => api.get('/pro_terms_of_use');
export const getPrivateBetaTermsOfUseContent = () => api.get('/private_beta_terms_of_use');
export const deleteConversationSuspicion = threadId => api.delete("/msg_threads/".concat(threadId, "/suspicion"));
export const getComplaint = id => api.get("/complaints/".concat(id));
export const getSecuritySettings = userId => api.get("/users/".concat(userId, "/security"));
export const setVoluntary2FA = (userId, isVoluntary2FA) => api.put("users/".concat(userId, "/security/voluntary_2fa"), {
  is_voluntary_2fa: isVoluntary2FA
});
export const createUser2FA = args => api.post("/users/".concat(args.userId, "/user_2fa"), {
  entity_id: args.entityId,
  type: args.entityType,
  fingerprint: args.fingerprint
});
export const submitPaymentsIdentity = args => api.put('/payments/identity', {
  payments_identity: transformers.submitPaymentsIdentityArgsToParams(args)
});
export const addAddress = args => api.post('/user_addresses', {
  user_address: transformers.addUserAddressArgsToParams(args)
});
export const getTaxAddress = () => api.get('/user_addresses/missing_info');
export const addShippingAddress = args => api.post("/transactions/".concat(args.transactionId, "/shipping_destination"), {
  user_address: transformers.addShippingAddressArgsToParams(args)
});
export const getDefaultBillingAddress = () => api.get('/user_addresses/default_billing_address');
export const addUserAddressesMissingInfo = user_address => api.post('/user_addresses/missing_info', {
  user_address
});
export const getDefaultShippingAddress = () => api.get('/user_addresses/default_shipping_address');
export const getInfoBanner = _ref59 => {
  let {
    screen,
    params
  } = _ref59;
  return api.get("/info_banners/".concat(screen), {
    params
  });
};
export const createPhoneNumber = (userId, phoneNumber) => api.post("/users/".concat(userId, "/phone_number"), {
  phone_number: {
    number: phoneNumber
  }
});
export const changePhoneNumber = _ref60 => {
  let {
    userId,
    currentNumber,
    newNumber,
    fingerprint
  } = _ref60;
  return api.post("/users/".concat(userId, "/phone_number/change"), {
    current_phone: currentNumber,
    new_phone: newNumber,
    fingerprint
  });
};
export const verifyPhoneNumber = _ref61 => {
  let {
    userId,
    code,
    phoneNumber,
    fingerprint
  } = _ref61;
  return api.put("/users/".concat(userId, "/phone_number/verify"), {
    code,
    phone_number: phoneNumber,
    fingerprint
  });
};
export const getReferralRegistrations = () => api.get('/referrals/registrations');
export const getReferralInviteInstructions = () => api.get('/referrals/invite_instructions');
export const getReferralShare = () => api.get('/referrals/share/new');
export const getAppLinks = url => api.get('/app_links', {
  params: {
    ids: url
  }
});
export const getCountryBounds = countryId => api.get("/countries/".concat(countryId, "/bounds"));
export const getWalletBalance = userId => api.get("users/".concat(userId, "/balance"), {
  headers: moneyObjectHeader
});
export const getItemSuggestions = _ref62 => {
  let {
    title,
    description,
    catalogId,
    photoIds
  } = _ref62;
  return api.get('items/suggestions', {
    params: {
      title,
      description,
      catalog_id: catalogId,
      photo_ids: photoIds.join(',')
    }
  });
};
export const getTrackingJourneySummary = _ref63 => {
  let {
    transactionId
  } = _ref63;
  return api.get("transactions/".concat(transactionId, "/shipment/journey_summary"));
};
export const getShipmentInstructions = _ref64 => {
  let {
    transactionId
  } = _ref64;
  return api.get("transactions/".concat(transactionId, "/shipment_instructions"), {
    headers: moneyObjectHeader
  });
};
export const getPostalCodeConfiguration = _ref65 => {
  let {
    code,
    countryId
  } = _ref65;
  return api.get("postal_codes/".concat(code), {
    params: {
      country_id: countryId
    }
  });
};
export const orderShippingLabel = _ref66 => {
  let {
    sellerAddressId,
    transactionId,
    pickUpDate,
    digitalLabelType
  } = _ref66;
  return api.put("transactions/".concat(transactionId, "/shipment/order"), {
    seller_address_id: sellerAddressId,
    pick_up_date: pickUpDate,
    digital_label_type: digitalLabelType
  });
};
export const linkFacebook = accessToken => api.post('facebook_user/link', {
  fb_access_token: accessToken
});
export const unlinkFacebook = () => api.delete('facebook_user');
export const linkGoogle = idToken => api.post('google_user/link', {
  id_token: idToken
});
export const unlinkGoogle = () => api.delete('google_user');
export const createPaymentsAccount = account => api.post("/users/".concat(account.userId, "/payments_account"), transformers.createPaymentsAccountArgsToParams(account));
export const getPaymentsAccount = userId => api.get("/users/".concat(userId, "/payments_account"));
export const getCurrentWalletInvoices = () => api.get('/wallet/invoices/current', {
  headers: moneyObjectHeader
});
export const getHistoricalWalletInvoices = (year, month) => api.get("/wallet/invoices/".concat(year, "/").concat(month), {
  headers: moneyObjectHeader
});
export const createPayout = args => api.post("/users/".concat(args.userId, "/payouts"), transformers.createPayoutArgsToParams(args));
export const getPayoutConfiguration = userId => api.get("/users/".concat(userId, "/payouts/new"));
export const getPayout = (userId, payoutId) => api.get("/users/".concat(userId, "/payouts/").concat(payoutId));
export const getRefund = transactionId => api.get("/transactions/".concat(transactionId, "/refund"));
export const getBankAccountRegistration = () => api.post('/payments/bank_account_registrations/prepare');
export const getBankAccounts = () => api.get('/bank_accounts');
export const addBankAccount = (bankAccount, fingerprint) => api.post('/bank_accounts', {
  bank_account: transformers.addBankAccountArgsToParams(bankAccount),
  fingerprint
});
export const deleteBankAccount = _ref67 => {
  let {
    bankAccountId,
    fingerprint
  } = _ref67;
  return api.delete("/bank_accounts/".concat(bankAccountId, "?fingerprint=").concat(fingerprint));
};
export const validateUser = _ref68 => {
  let {
    user
  } = _ref68;
  return api.post('/users/validations', {
    user
  });
};
export const uploadKbisFile = file => {
  const data = new FormData();
  data.append('file', file);
  return api.post('/business_accounts/kbis', data);
};
export const validateBusinessUboAddress = business_ubo_address => api.post('/user_addresses/validate_business_ubo_address', {
  business_ubo_address
});
export const validateBusinessRegistration = registration => api.post('/business_accounts/validate', registration);
export const validateBusinessRegistrationDsa = registration => api.post('/business_accounts_dsa/validate', registration);
export const submitBusinessRegistration = registration => api.post('/business_accounts', registration);
export const submitBusinessRegistrationDsa = registration => api.post('/business_accounts_dsa', registration);
export const deleteBusinessRegistration = userId => api.delete("/business_accounts/".concat(userId));
export const getBusinessAccountPolicies = _ref69 => {
  let {
    businessAccountId
  } = _ref69;
  return api.get("/business_accounts/".concat(businessAccountId, "/terms"));
};
export const setBusinessAccountPolicies = args => api.post("/business_accounts/".concat(args.businessAccountId, "/terms"), transformers.setBusinessAccountPoliciesArgsToParams(args));
export const getBusinessAccountAddresses = _ref70 => {
  let {
    businessAccountId
  } = _ref70;
  return api.get("/business_accounts/".concat(businessAccountId, "/addresses"));
};
export const setBusinessAccountAddresses = _ref71 => {
  let {
    businessAccountId
  } = _ref71,
      args = _objectWithoutProperties(_ref71, _excluded);

  return api.post("/business_accounts/".concat(businessAccountId, "/addresses"), transformers.setBusinessAccountAddressesArgsToParams(args));
};
export const enterTrackingCode = _ref72 => {
  let {
    transactionId,
    trackingCode
  } = _ref72;
  return api.put("/transactions/".concat(transactionId, "/shipment/enter_tracking_code"), {
    id: transactionId,
    tracking_code: trackingCode
  });
};
export const getWorldCountries = () => api.get('/world_countries');
export const getExtraServicePayment = paymentId => api.get("/extra_services/payments/".concat(paymentId));
export const updateExtraServicePaymentData = (paymentId, args) => api.put("/extra_services/payments/".concat(paymentId, "/payment_data"), transformers.updateExtraServicePaymentArgsToParams(args));
export const confirmExtraServiceOrder = args => api.post('/extra_services/payments', transformers.confirmExtraServiceOrderArgsToParams(args));
export const dismissListerActivationBanners = () => api.post('/banners/lister_activation/dismissed');
export const dismissTaxpayerBanner = () => api.post('/banners/taxpayer_banner/dismissed');
export const createFeaturedCollection = _ref73 => {
  let {
    title,
    itemIds,
    discount,
    isActive
  } = _ref73;
  return api.post('/featured_collections', {
    title,
    item_ids: itemIds,
    discount,
    active: isActive
  });
};
export const editFeaturedCollection = _ref74 => {
  let {
    id,
    title,
    itemIds,
    discount,
    isActive
  } = _ref74;
  return api.put("/featured_collections/".concat(id), {
    title,
    item_ids: itemIds,
    discount,
    active: isActive
  });
};
export const deleteFeaturedCollection = _ref75 => {
  let {
    id
  } = _ref75;
  return api.delete("/featured_collections/".concat(id));
};
export const getFeaturedCollections = _ref76 => {
  let {
    userId
  } = _ref76;
  return api.get("/users/".concat(userId, "/featured_collections"), {
    headers: moneyObjectHeader
  });
};
export const getFeaturedCollectionPricing = () => api.get('/featured_collections/pricing');
export const getCollectionsPlansPricing = () => api.get('/collections/pricing');
export const getCollections = _ref77 => {
  let {
    userId
  } = _ref77;
  return api.get("/users/".concat(userId, "/collections"));
};
export const prepareFeaturedCollectionOrder = _ref78 => {
  let {
    planId
  } = _ref78;
  return api.post('/featured_collections/orders/prepare', planId ? {
    pricing_id: planId
  } : undefined);
};
export const getFeaturedCollectionOrder = orderId => api.get("/featured_collections/orders/".concat(orderId));
export const calculateDiscount = _ref79 => {
  let {
    itemIds,
    discount
  } = _ref79;
  return api.post('/items/discount/calculate', {
    item_ids: itemIds,
    discount
  });
};
export const getStatuses = () => api.get('/statuses');
export const verifyCaptcha = _ref80 => {
  let {
    uuid,
    captchaToken
  } = _ref80;
  return api.patch("/captchas/".concat(uuid), {
    captcha_token: captchaToken
  });
};
export const getCaptchaVerification = _ref81 => {
  let {
    entityType,
    payload
  } = _ref81;
  return api.post('/captchas', {
    entity_type: entityType,
    payload
  });
};
export const getFeedbackProblemOptions = (userId, conversationId) => api.get("/users/".concat(userId, "/msg_threads/").concat(conversationId, "/problem_options"));
export const sendFeedbackProblemFeedback = args => api.post("/users/".concat(args.userId, "/msg_threads/").concat(args.conversationId, "/problem_options"), {
  problem_option_id: args.problemOptionId,
  message: args.message
});
export const getConversationFeedbackRatingOptions = (userId, conversationId) => api.get("/users/".concat(userId, "/msg_threads/").concat(conversationId, "/feedback_ratings"));
export const updateFeedbackRatingOptions = (userId, conversationId, args) => api.put("/users/".concat(userId, "/msg_threads/").concat(conversationId, "/feedback_ratings"), transformers.updateFeedbackRatingOptionsArgsToParams(args));
export const setSelectedDropOffTypeMethod = args => api.put("transactions/".concat(args.transactionId, "/shipment/set_drop_off_type"), {
  drop_off_type_id: args.dropOffTypeId
});
export const getMentionSuggestions = _ref82 => {
  let {
    query
  } = _ref82;
  return api.get('/mention_suggestions', {
    params: {
      query
    }
  });
};
export const getForumGroups = () => api.get('/forum_groups');
export const getForumUserTopics = _ref83 => {
  let {
    page,
    userId,
    perPage
  } = _ref83;
  return api.get("users/".concat(userId, "/forum_topics"), {
    params: {
      page,
      per_page: perPage
    }
  });
};
export const getPayInMethods = userId => api.get("/users/".concat(userId, "/pay_in_methods"));
export const getTransactionPayInMethods = transactionId => api.get("/transactions/".concat(transactionId, "/pay_in_methods"));
export const getExtraServicePayInMethods = () => api.get('/extra_services/pay_in_methods');
export const getBusinessAccountInvoiceInstructions = _ref84 => {
  let {
    transactionId
  } = _ref84;
  return api.get("transactions/".concat(transactionId, "/business_account_invoice_instructions"));
};
export const deleteForumPost = postId => api.delete("/forum_posts/".concat(postId));
export const prepareCreditCardRegistration = _ref85 => {
  let {
    name,
    cardBrand
  } = _ref85;
  return api.post('/payments/credit_card_registrations/prepare', {
    credit_card_registration: {
      name,
      card_brand: cardBrand
    }
  });
};
export const getUserPermissions = requests.getUserPermissionsRequest(api);
export const registerCreditCard = args => api.post('/payments/credit_cards', transformers.registerCreditCardArgsToParams(args));
export const authenticateCreditCard = args => api.put('/payments/credit_cards/authentication_details', transformers.authenticateCreditCardArgsToParams(args));
export const getCreditCardRegistration = () => api.get('/payments/credit_card_registrations/new');
export const getCreditCardRegistrationBrands = bin => api.get('/payments/credit_card_registrations/brands', {
  params: {
    bin
  }
});
export const getForumPosts = args => api.get("/forum_topics/".concat(args.topicId, "/forum_posts"), {
  params: {
    page: args.page,
    per_page: args.per_page
  }
});
export const getForumById = forumId => api.get("/forums/".concat(forumId));
export const getForum = slug => api.get('/forums', {
  params: {
    slug
  }
});
export const getForumPost = postId => api.get("/forum_posts/".concat(postId));
export const getForumTopic = topicId => api.get("/forum_topics/".concat(topicId));
export const getForumTopics = args => api.get("/forums/".concat(args.forumId, "/forum_topics"), {
  params: {
    page: args.page,
    sub_forum_id: args.subforumId,
    per_page: args.perPage
  }
});
export const createForumTopic = _ref86 => {
  let {
    title,
    body,
    isAnonymous,
    forumId,
    subforumId,
    assignedPhotos
  } = _ref86;
  return api.post("/forums/".concat(forumId, "/forum_topics"), {
    forum_topic: {
      title,
      body,
      is_anonymous: isAnonymous,
      sub_forum_id: subforumId
    },
    assigned_photos: assignedPhotos === null || assignedPhotos === void 0 ? void 0 : assignedPhotos.map(id => ({
      id
    }))
  });
};
export const updateForumPost = _ref87 => {
  let {
    id,
    body,
    isAnonymous,
    assignedPhotos,
    photoTempUuid
  } = _ref87;
  return api.put("/forum_posts/".concat(id), {
    forum_post: {
      body,
      is_anonymous: isAnonymous,
      photo_temp_uuid: photoTempUuid
    },
    assigned_photos: assignedPhotos === null || assignedPhotos === void 0 ? void 0 : assignedPhotos.map(photoId => ({
      id: photoId
    }))
  });
};
export const createForumPost = _ref88 => {
  let {
    topicId,
    body,
    isAnonymous,
    photoTempUuid,
    assignedPhotos,
    replyPostId
  } = _ref88;
  return api.post("/forum_topics/".concat(topicId, "/forum_posts"), {
    forum_post: {
      body,
      is_anonymous: isAnonymous,
      photo_temp_uuid: photoTempUuid,
      reply_post_id: replyPostId
    },
    assigned_photos: assignedPhotos === null || assignedPhotos === void 0 ? void 0 : assignedPhotos.map(id => ({
      id
    }))
  });
};
export const likeForumPost = postId => api.post("/forum_posts/".concat(postId, "/like"));
export const unlikeForumPost = postId => api.delete("/forum_posts/".concat(postId, "/like"));
export const getUsers = _ref89 => {
  let {
    perPage,
    searchText,
    page,
    order,
    itemId
  } = _ref89;
  return api.get('/users', {
    params: {
      page,
      order,
      per_page: perPage,
      search_text: searchText,
      order_by_buyer_for_item: itemId
    }
  });
};
export const getUserFollowers = _ref90 => {
  let {
    userId,
    perPage,
    page
  } = _ref90;
  return api.get("users/".concat(userId, "/followers"), {
    params: {
      per_page: perPage,
      page
    }
  });
};
export const getFollowedUsers = _ref91 => {
  let {
    userId,
    perPage,
    page
  } = _ref91;
  return api.get("users/".concat(userId, "/followed_users"), {
    params: {
      per_page: perPage,
      page
    }
  });
};
export const getFollowUsers = _ref92 => {
  let {
    userId,
    perPage,
    page
  } = _ref92;
  return api.get("users/".concat(userId, "/followed_users"), {
    params: {
      per_page: perPage,
      page
    }
  });
};
export const deleteConversation = id => api.delete("/conversations/".concat(id));
export const updateForumTopic = _ref93 => {
  let {
    id,
    title,
    subforumId,
    forumId
  } = _ref93;
  return api.put("/forum_topics/".concat(id), {
    forum_topic: {
      title,
      forum_id: forumId,
      sub_forum_id: subforumId
    }
  });
};
export const getNewestForumTopics = function () {
  let {
    page,
    perPage
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return api.get('forum_topics/news', {
    params: {
      page,
      per_page: perPage
    }
  });
};
export async function getRecentUsers(keyword) {
  return api.get('/help_center/recent_users', {
    params: {
      keyword
    }
  });
}
export const getRecentTransactions = count => api.get('help_center/recent_transactions', {
  params: {
    count
  },
  headers: moneyObjectHeader
});
export const getRecentItems = () => api.get('help_center/recent_items', {
  headers: moneyObjectHeader
});
export const getMyOrders = _ref94 => {
  let {
    page,
    perPage,
    type,
    status
  } = _ref94;
  return api.get('my_orders', {
    params: {
      page,
      per_page: perPage,
      type,
      status
    },
    headers: moneyObjectHeader
  });
};
export const getProfileUserInfo = userId => api.get("users/".concat(userId, "/profile"));
export const getTransactionCancellationReasons = id => api.get("/transactions/".concat(id, "/cancellation_reasons"));
export const cancelTransaction = _ref95 => {
  let {
    id,
    reasonId,
    userExplanation
  } = _ref95;
  return api.put("/transactions/".concat(id, "/cancel"), {
    reason: {
      id: reasonId,
      user_explanation: userExplanation
    }
  });
};
export const createSupportTicket = args => api.post('/help_center/support_tickets', transformers.getCreateSupportTicketArgs(args));
export const getLegalEntity = legalCode => api.get('/business_accounts/legal_entity', {
  params: {
    legal_code: legalCode
  }
});
export const updateBusinessAccountBankDetails = _ref96 => {
  let {
    bankAccountOwnerName,
    bankAccountNumber
  } = _ref96;
  return api.put('/business_accounts_dsa', {
    bank_account_number: bankAccountNumber,
    bank_account_owner_name: bankAccountOwnerName
  });
};
export const deleteForumTopic = id => api.delete("/forum_topics/".concat(id));
export const reserveItem = _ref97 => {
  let {
    id,
    buyerId
  } = _ref97;
  return api.post("/items/".concat(id, "/reservation"), {
    to_whom_id: buyerId
  });
};
export const getNotificationSettings = function (userId) {
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'email';
  return api.get("/users/".concat(userId, "/notification_settings"), {
    params: {
      type
    }
  });
};
export const updateNotificationSettings = (userId, settings) => api.put("/users/".concat(userId, "/notification_settings"), {
  notification_settings: {
    email: settings
  }
});
export const convertBusinessWallet = () => api.post('/business_accounts/conversion');
export const getWalletConversionStatus = requests.getWalletConversionStatusRequest(api);
export const getCarrierPreferences = userId => api.get("/users/".concat(userId, "/carrier_preferences"));
export const updateCarrierPreference = _ref98 => {
  let {
    userId,
    carrierId,
    enabled
  } = _ref98;
  return api.put("/users/".concat(userId, "/carriers/").concat(carrierId, "/preference"), {
    carrier_preference: {
      enabled
    }
  });
};
export const getDigitalLabel = _ref99 => {
  let {
    transactionId
  } = _ref99;
  return api.get("/transactions/".concat(transactionId, "/shipment/digital_label"));
};
export const getShippingContactConfiguration = () => api.get('/configurations/shipping_contact');
export const saveTransactionShippingContact = args => api.post("/transactions/".concat(args.transactionId, "/shipping_contact"), {
  save_for_later: args.saveForLater,
  shipping_contact: omitBy({
    buyer_phone_number: args.buyerPhoneNumber,
    seller_phone_number: args.sellerPhoneNumber
  }, isNil)
});
export const deleteTransactionShippingContact = transactionId => api.delete("/transactions/".concat(transactionId, "/shipping_contact"));
export const getOfferRequestOptions = _ref100 => {
  let {
    itemPrice
  } = _ref100;
  return api.post('/offers/request_options', {
    price: {
      amount: itemPrice.amount,
      currency_code: itemPrice.currencyCode
    }
  });
};
export const createOfferRequest = _ref101 => {
  let {
    price,
    currency,
    transactionId
  } = _ref101;
  return api.post("/transactions/".concat(transactionId, "/offer_requests"), {
    offer_request: {
      price,
      currency
    }
  });
};
export const createOffer = _ref102 => {
  let {
    transactionId,
    price,
    currency
  } = _ref102;
  return api.post("/transactions/".concat(transactionId, "/offers"), {
    offer: {
      price,
      currency
    }
  });
};
export const getDataExportStatus = userId => api.get("/users/".concat(userId, "/personal_data_export"));
export const requestDataExport = _ref103 => {
  let {
    userId,
    fingerprint
  } = _ref103;
  return api.post("/users/".concat(userId, "/personal_data_export"), {
    fingerprint
  });
};
export const confirmDataExport = _ref104 => {
  let {
    userId,
    code
  } = _ref104;
  return api.post("/users/".concat(userId, "/personal_data_export/confirmation"), {
    code
  });
};
export const createAdminAlert = args => api.post("/users/".concat(args.userId, "/admin_alerts"), transformers.createAdminAlertArgsToParams(args));
export const getReportReasons = alertType => api.get("/report_reasons/".concat(alertType));
export const searchForumPosts = args => api.get('/forum_posts', {
  params: {
    page: args.page,
    per_page: args.perPage,
    search_text: args.searchText
  }
});
export const getForumSavedTopics = _ref105 => {
  let {
    page,
    userId,
    perPage
  } = _ref105;
  return api.get("users/".concat(userId, "/forum_topics/favourites"), {
    params: {
      page,
      per_page: perPage
    }
  });
};
export const getItemServiceFee = itemId => api.get("/items/".concat(itemId, "/service_fee"));
export const acceptOffer = _ref106 => {
  let {
    transactionId,
    offerRequestId
  } = _ref106;
  return api.put("/transactions/".concat(transactionId, "/offer_requests/").concat(offerRequestId, "/accept"));
};
export const rejectOffer = _ref107 => {
  let {
    transactionId,
    offerRequestId
  } = _ref107;
  return api.put("/transactions/".concat(transactionId, "/offer_requests/").concat(offerRequestId, "/reject"));
};
export const sendProductFeedback = args => api.post('/app_feedbacks', _objectSpread(_objectSpread({}, args), {}, {
  user_id: args.userId
}));
export const getPushUpFeedbackRatingOptions = (userId, conversationId) => api.get("/users/".concat(userId, "/msg_threads/").concat(conversationId, "/promoted_item_feedback_ratings"));
export const updatePushUpFeedbackRatingOptions = (userId, conversationId, args) => api.put("/users/".concat(userId, "/msg_threads/").concat(conversationId, "/promoted_item_feedback_ratings"), transformers.updateFeedbackRatingOptionsArgsToParams(args));
export const deleteMessage = _ref108 => {
  let {
    conversationId,
    messageId
  } = _ref108;
  return api.delete("conversations/".concat(conversationId, "/replies/").concat(messageId));
};
export const deletePhotoMessage = _ref109 => {
  let {
    conversationId,
    messageId,
    photoId
  } = _ref109;
  return api.delete("/conversations/".concat(conversationId, "/replies/").concat(messageId, "/photos/").concat(photoId));
};
export const postLikeMessage = _ref110 => {
  let {
    conversationId,
    messageId,
    reactionType
  } = _ref110;
  return api.post("conversations/".concat(conversationId, "/replies/").concat(messageId, "/reactions"), {
    type: reactionType
  });
};
export const deleteLikeMessage = _ref111 => {
  let {
    conversationId,
    messageId,
    reactionId
  } = _ref111;
  return api.delete("conversations/".concat(conversationId, "/replies/").concat(messageId, "/reactions/").concat(reactionId));
};
export const postLikeMessagePhoto = _ref112 => {
  let {
    conversationId,
    messageId,
    photoId,
    reactionType
  } = _ref112;
  return api.post("conversations/".concat(conversationId, "/replies/").concat(messageId, "/photos/").concat(photoId, "/photo_reactions"), {
    type: reactionType
  });
};
export const deleteLikeMessagePhoto = _ref113 => {
  let {
    conversationId,
    messageId,
    photoId,
    reactionId
  } = _ref113;
  return api.delete("conversations/".concat(conversationId, "/replies/").concat(messageId, "/photos/").concat(photoId, "/photo_reactions/").concat(reactionId));
};
export const getKycEducationInfo = () => api.get('/payments/identity/education');
export const markEducationAsRead = type => api.post('/user/education', {
  type
});
export const getClosetPromotionOrder = orderId => api.get("promoted_closets/orders/".concat(orderId));
export const getClosetPromotionPerformance = () => api.get('promoted_closets/performances');
export const getClosetPromoPerformanceFeedbackRatingOptions = () => api.get('/promoted_closets/performance_feedback');
export const updateClosetPromoPerformanceFeedbackRatingOptions = args => api.put('/promoted_closets/performance_feedback', transformers.updateFeedbackRatingOptionsArgsToParams(args));
export const getBrazeEventProperties = _ref114 => {
  let {
    eventName,
    modelId
  } = _ref114;
  return api.get('/external_crm/event_payload', {
    params: {
      event_name: eventName,
      model_id: modelId
    }
  });
};
export const getCourierPickUpDates = transactionId => api.get("/transactions/".concat(transactionId, "/shipment/pick_up_dates"));
export const getRequestReturnDetails = transactionId => api.get("/transactions/".concat(transactionId, "/shipment/request_return_details"));
export const createReturnShipment = transactionId => api.post("/transactions/".concat(transactionId, "/shipment/return_shipment"));
export const createComplaintEscalation = (complaintId, englishResponseAllowed) => api.post("/complaints/".concat(complaintId, "/escalate"), {
  english_allowed: englishResponseAllowed
});
export const sendIntellectualPropertyInfringement = (formData, captchaToken) => api.post('/brand_complaints', transformers.sendIntellectualPropertyInfringementArgsToParams(formData, captchaToken));
export const uploadReportAttachment = (file, captchaToken) => {
  const data = new FormData();
  data.append('file', file);
  if (captchaToken) data.append('captcha_token', captchaToken);
  return api.post('/brand_complaints/attachments', data);
};
export const verifyIntellectualPropertyInfringementCaptcha = key => api.post('/brand_complaints/captchas', {
  captcha_token: key
});
export const getUserStats = userId => api.get("/users/".concat(userId, "/stats"), {
  headers: moneyObjectHeader
});
export const getUserBuyCount = () => api.get('/tracker_attributes', {
  params: {
    type: 'buy_debit_transactions'
  }
});
export const getClosetPromotionPricing = () => api.get('/promoted_closets/pricing');
export const getUserFavouritesItemsGroups = () => api.get('/user_favourites/items/groups');
export const getUserFavouritesItemsGroupAll = () => api.get('/user_favourites/items/group/all');
export const createUserFavouritesItemsGroup = _ref115 => {
  let {
    name
  } = _ref115;
  return api.post('/user_favourites/items/groups', {
    group_name: name
  });
};
export const getUserFavouritesItemsGroup = _ref116 => {
  let {
    id
  } = _ref116;
  return api.get("/user_favourites/items/group/".concat(id));
};
export const updateUserFavouritesItemsGroup = _ref117 => {
  let {
    id,
    name
  } = _ref117;
  return api.put("/user_favourites/items/groups/".concat(id), {
    group_name: name
  });
};
export const deleteUserFavouritesItemsGroup = _ref118 => {
  let {
    id
  } = _ref118;
  return api.delete("/user_favourites/items/groups/".concat(id));
};
export const addUserFavouriteItemsToGroup = _ref119 => {
  let {
    groupId,
    itemIds
  } = _ref119;
  return api.put("/user_favourites/items/group/".concat(groupId), {
    user_favourite_items: itemIds
  });
};
export const getUngroupedUserFavouriteItems = () => api.get('/user_favourites/items/group/none');
export const downloadShippingLabel = transactionId => api.get("/transactions/".concat(transactionId, "/shipment/pdf_label"));
export const blockUser = _ref120 => {
  let {
    currentUserId,
    blockedUserId
  } = _ref120;
  return api.post("/users/".concat(currentUserId, "/user_hates"), {
    hated_user_id: blockedUserId
  });
};
export const unblockUser = _ref121 => {
  let {
    currentUserId,
    blockedUserId
  } = _ref121;
  return api.delete("/users/".concat(currentUserId, "/user_hates"), {
    params: {
      hated_user_id: blockedUserId
    }
  });
};
export const getDirectDonationConfiguration = () => api.get('/direct_donations/orders/new');
export const createDirectDonationOrder = args => api.post('/direct_donations/orders/prepare', transformers.createDirectDonationOrderArgsToParams(args), {
  headers: moneyObjectHeader
});
export const getDirectDonationOrder = orderId => api.get("direct_donations/orders/".concat(orderId), {
  headers: moneyObjectHeader
});
export const getNearbyShippingOptions = args => api.get("/transactions/".concat(args.transactionId, "/nearby_shipping_options"), {
  params: transformers.getNearbyShipmentOptionsArgsToParams(args),
  headers: moneyObjectHeader
}); // This is used as POST because we want to pass the item_attributes as a JSON object)

export const getPackageShippingOptions = _ref122 => {
  let {
    packageSizeId,
    catalogId,
    brandId,
    price
  } = _ref122;
  return api.post("/package_sizes/".concat(packageSizeId, "/shipping_options"), {
    item_attributes: {
      catalog_id: catalogId,
      brand_id: brandId,
      price
    }
  });
};
export const getSuggestedPackageSizeCode = _ref123 => {
  let {
    item
  } = _ref123;
  return api.post('/package_sizes/suggestion', {
    item
  });
};
export const getAdsPlacements = args => requests.getAdsPlacementsRequest(api)(args);
export const getAdsSegmentIds = requests.getAdsSegmentIdsRequest(api);
export const getShipmentItems = transactionId => api.get("/transactions/".concat(transactionId, "/shipment/items"));
export const getReturnShippingOptions = transactionId => api.get("/transactions/".concat(transactionId, "/shipment/return_shipping_options"));
export const getDeliveryTypes = transactionId => api.get("/transactions/".concat(transactionId, "/delivery_types"));
export const createCustomReturnShipment = _ref124 => {
  let {
    transactionId,
    returnShippingOption
  } = _ref124;
  return api.post("/transactions/".concat(transactionId, "/shipment/return_shipping_option"), {
    return_shipping_option: returnShippingOption
  });
};
export const getFundraiserConfiguration = () => api.get('/fundraiser');
export const getCharities = () => api.get('/charities');
export const updateFundraiser = _ref125 => {
  let {
    percentage,
    charityCode
  } = _ref125;
  return api.put('/fundraiser', {
    fundraiser: {
      charity_code: charityCode,
      percentage
    }
  });
};
export const getItemShippingDetails = itemId => api.get("/items/".concat(itemId, "/shipping_details"), {
  headers: moneyObjectHeader
});
export const deleteFundraiser = () => api.delete('/fundraiser');
export const getBrazeAuthToken = () => api.get('/external_crm/jwts');
export const getTranslations = requests.getTranslationsRequest(api);
export const getConversation = requests.getConversationRequest(api);
export const getFeatureSwitches = requests.getFeatureSwitchesRequest(api);
export const getNationalities = () => api.get('/nationalities');
export const markAsSold = _ref126 => {
  let {
    itemId,
    buyerId,
    closingAction,
    price,
    currency
  } = _ref126;
  return api.post("/items/".concat(itemId, "/mark_as_sold"), {
    receiver_id: buyerId,
    closing_action: closingAction,
    price,
    currency
  }, {
    headers: moneyObjectHeader
  });
};
export const markAsUnreserved = _ref127 => {
  let {
    itemId
  } = _ref127;
  return api.delete("items/".concat(itemId, "/reservation"));
};
export const getSizesConfiguration = () => api.get('/sizes_configuration');
export const markSizeModalAsSeen = () => api.put('/sizes_configuration');
export const getFaqEntryFeedbackData = faqId => api.get("/faq_entries/".concat(faqId, "/feedback"));
export const updateFaqEntryFeedbackForm = args => api.patch("/faq_entries/".concat(args.faqId, "/feedback"), transformers.updateFaqEntryFeedbackArgsToParams(args));
export const getVerificationPrompt = requests.getVerificationPromptRequest(api);
export const dismissVerificationPrompt = userId => api.delete("/users/".concat(userId, "/verifications/prompt"));
export const sendEmailVerificationCode = _ref128 => {
  let {
    userId,
    email
  } = _ref128;
  return api.post("/users/".concat(userId, "/verifications/email_code"), {
    email
  });
};
export const validateEmailVerificationCode = _ref129 => {
  let {
    userId,
    code
  } = _ref129;
  return api.put("/users/".concat(userId, "/verifications/email_code"), {
    code
  });
};
export const setCategoryIntent = intent => api.post('/category_intent', {
  intent
});
export const getShippingDates = transactionId => api.get("/transactions/".concat(transactionId, "/shipment/shipping_date_selection/new"));
export const updateShippingDate = args => api.put("/transactions/".concat(args.transactionId, "/shipment/shipping_date_selection"), transformers.updateShippingDateArgsToParams(args));
export const markAsDeliveredToSender = transactionId => api.put("/transactions/".concat(transactionId, "/shipment/mark_as_return_to_sender_completed"));
export const confirmTransactionInstructions = transactionId => api.put("/transactions/".concat(transactionId, "/shipment/confirm_instructions"));
export const getUserSessions = userId => api.get("users/".concat(userId, "/sessions"));
export const deleteUserSession = _ref130 => {
  let {
    userId,
    sessionId,
    fingerprint
  } = _ref130;
  return api.delete("/users/".concat(userId, "/sessions/").concat(sessionId, "?fingerprint=").concat(fingerprint));
};
export const getSessionDefaults = () => api.get('/configurations/session_defaults');
export const getReservationLink = transactionId => api.get("/transactions/".concat(transactionId, "/shipment/reservation_link"));
export const reserveTransactionItems = (transactionId, reserved) => api.put("/transactions/".concat(transactionId, "/reservation"), {
  reserved
});
export const getShippingInstructions = transactionId => api.get("/transactions/".concat(transactionId, "/shipping_instructions"));
export const disableUserHoliday = userId => api.delete("/users/".concat(userId, "/holiday"));
export const getDomainSelection = () => requests.getDomainSelectionRequest(api);
export const getGoogleIdToken = _ref131 => {
  let {
    code,
    state,
    action
  } = _ref131;
  return api.get('/google_user/token', {
    params: {
      code,
      state,
      take_action: action
    }
  });
};
export const getTaxpayerEducation = () => api.get('/taxpayers/education');
export const getTaxpayerFormConfiguration = countryCode => api.get("/taxpayers/form/".concat(countryCode));
export const changePassword = _ref132 => {
  let {
    userId,
    currentPassword,
    newPassword,
    fingerprint
  } = _ref132;
  return api.put("/users/".concat(userId, "/password"), {
    old_password: currentPassword,
    password: newPassword,
    fingerprint
  });
};
export const changeForgotPassword = _ref133 => {
  let {
    code,
    password,
    passwordConfirmation,
    fingerprint
  } = _ref133;
  return api.post('/users/change_forgot_password', {
    code,
    password,
    password_confirmation: passwordConfirmation,
    fingerprint
  });
};
export const getForgotPasswordConfirmationCode = _ref134 => {
  let {
    code
  } = _ref134;
  return api.get('/users/forgot_password', {
    params: {
      code
    }
  });
};
export const getVasGallery = args => api.get('/vas_gallery/items', {
  params: transformers.getVasGalleryArgsToParams(args)
});
export const getVasGalleryPricing = itemsIds => api.get('/vas_gallery/pricing', {
  params: {
    item_ids: itemsIds
  }
});
export const postVasGalleryOrder = itemsIds => api.post('/vas_gallery/orders', {
  item_ids: itemsIds
});
export const getVasGalleryOrder = orderId => api.get("/vas_gallery/orders/".concat(orderId));
export const getItemConfiguration = async () => api.get('/configurations/item', {
  headers: moneyObjectHeader
});
export const getDynamicAttributes = args => api.get('/catalog_attributes', {
  params: transformers.getDynamicAttributesArgsToParams(args)
});
export const updateTaxpayerFormData = args => api.put('/taxpayers/form', transformers.updateTaxpayerFormDataArgsToParams(args));
export const getTaxpayerFormStatus = () => api.get('/taxpayers/form/status');
export const prepareReturnLabelOrder = _ref135 => {
  let {
    transactionId,
    pickupPointCode,
    packageTypeId,
    addressId
  } = _ref135;
  return api.post('/return_label/orders/prepare', {
    transaction_id: transactionId,
    pickup_point_code: pickupPointCode,
    package_type_id: packageTypeId,
    address_id: addressId
  });
};
export const getReturnLabelOrder = orderId => api.get("/return_label/orders/".concat(orderId));
export const getUserObligations = userId => api.get("/users/".concat(userId, "/obligations"));
export const checkIsAlertsGeneratorBusy = () => api.get('/admin/alert_generators/is_busy');
export const generateAlertsFromSearchParams = _ref136 => {
  let {
    searchParams,
    reportReason
  } = _ref136;
  return api.post('/admin/alert_generators/execute', {
    item_search_params: searchParams,
    report_reason_code: reportReason
  });
};
export const getWalletIncomeSettings = () => api.get('/wallet/income_reports/settings');
export const getInvoicesAvailableDates = () => api.get('/invoices/available_dates');
export const getInvoicesByDate = _ref137 => {
  let {
    year,
    month
  } = _ref137;
  return api.get("/invoices/".concat(year, "/").concat(month));
};
export const getSatisfactionSurvey = (userId, transactionId) => api.get("/users/".concat(userId, "/satisfaction_survey?transaction_id=").concat(transactionId || ''));
export const getFeedbackSummary = userId => api.get("/user_feedbacks/summary?user_id=".concat(userId));
export const skipTermsAndConditions = () => api.post('/terms/skip');
export const acceptTermsAndConditions = id => api.put("/users/".concat(id, "/agree_terms"));
export const saveSatisfactionSurveyAnswers = _ref138 => {
  let {
    userId,
    transactionId,
    answers
  } = _ref138;
  return api.post("/users/".concat(userId, "/satisfaction_survey?transaction_id=").concat(transactionId || ''), {
    answers,
    comment: answers.comment
  });
};
export const getInfoBoardPosts = () => api.get('/info_posts');
export const getTermsAndConditions = () => api.get('/terms_and_conditions');
export const getTaxpayerBusinessEstablishmentCountries = () => api.get('/taxpayers/form/business_establishment_countries');
export const getInfoBoardPost = postId => api.get("/info_posts/".concat(postId));
export const getNotificationLandings = code => api.get("/notification_landings/".concat(code));
export const getIsSatisfactionSurveyEnabled = _ref139 => {
  let {
    userId,
    transactionId
  } = _ref139;
  return api.get("/users/".concat(userId, "/satisfaction_survey/enabled?transaction_id=").concat(transactionId || ''));
};
export function getFidoCredentialOptions() {
  return api.get('/users/fido_authentications/prepare_registration');
}
export function registerFidoCredential(_ref140) {
  let {
    attestation
  } = _ref140;
  return api.post('/users/fido_authentications/verify_registration', {
    attestation
  });
}
export function getFidoVerificationCredentialOptions() {
  return api.get('/users/fido_authentications/prepare_verification');
}
export function verifyFidoCredential(_ref141) {
  let {
    attestation
  } = _ref141;
  return api.post('/users/fido_authentications/verify_verification', {
    attestation
  });
}
export function deleteFidoCredentials(userId) {
  return api.delete("/users/".concat(userId, "/security/delete_fido_credentials"));
}
export const getSimilarItemsById = _ref142 => {
  let {
    itemId
  } = _ref142;
  return api.get("/items/".concat(itemId, "/similar_items"));
};
export const getTermsAndConditionsContent = () => api.get('/terms_and_conditions/content');
export const getPrivacyPolicy = () => api.get('/privacy_policy');
export const getIsFundraiserEnabled = () => api.get('/fundraiser/enabled');
export const getItemBreadcrumbs = _ref143 => {
  let {
    catalogId,
    brandId
  } = _ref143;
  return api.get("/catalogs/".concat(catalogId, "/breadcrumbs"), {
    params: {
      brand_id: brandId
    }
  });
};
export const getNearbyDropOffPoints = args => api.get("/shipments/".concat(args.shipmentId, "/nearby_drop_off_points"), {
  params: transformers.addNearbyDropOffPointArgsToParams(args)
});
export const createDsaNoticeAppeal = args => api.post('/dsa/appeals/submit', transformers.getDsaNoticeCreateAppealArgs(args));
export const createDsaReporterAppeal = args => api.post('/dsa/reporter_appeals/submit', transformers.getDsaNoticeCreateAppealArgs(args));
export const createDsaNtdAppeal = args => api.post('/dsa/ntd_appeals/submit', transformers.getCreateDsaNtdAppealArgs(args));
export const getTaxRules = countryId => api.get("/taxpayers/tax_rules/".concat(countryId));
export const getInSiteSeoContent = _ref144 => {
  let {
    contentType,
    key,
    value
  } = _ref144;
  return api.get("/cms/".concat(contentType), {
    params: {
      key,
      value
    }
  });
};
export const getAvailableUserItemsForCollection = args => api.get('/collections/available_items', {
  params: transformers.getAvailableUserItemsForCollectionArgsToParams(args)
});
export const getCollectionPolicy = () => api.get('/collections/policy');
export const getFeaturedCollection = _ref145 => {
  let {
    id
  } = _ref145;
  return api.get("/featured_collections/".concat(id));
};
export const getCollection = _ref146 => {
  let {
    id
  } = _ref146;
  return api.get("/collections/".concat(id));
};
export const editCollectionsPositions = _ref147 => {
  let {
    activeCollectionIds,
    inactiveCollectionIds
  } = _ref147;
  return api.put('/collections/positions', {
    active_collection_ids: activeCollectionIds,
    inactive_collection_ids: inactiveCollectionIds
  });
};
export const getReferrer = () => api.get('/referrals/referrer');
export const postAdvertisingLeadForm = args => api.post('/ads/lead', {
  params: transformers.postAdvertisingLeadFormArgsToParams(args)
});
export const getOfflineVerificationAwareness = () => api.get('/offline_verification/awareness');
export const getSellerOfferOptions = _ref148 => {
  let {
    transactionId
  } = _ref148;
  return api.get("/transactions/".concat(transactionId, "/offers/seller_options"));
};
export const getIconsExplanation = itemId => api.get("items/".concat(itemId, "/badges"));
export const markFirstTimeListerEducationAsRead = () => api.delete('conversation_safety/education/first_time_listers');
export const exposeCollections = userId => api.post('/collections/expose', {
  closet_owner_id: userId
});
export const dismissTaxpayerRestrictionModal = () => api.post('/taxpayers/banners/taxpayer_banner/dismiss_modal');
export const dismissTaxpayerRestrictionBanner = () => api.post('/taxpayers/banners/taxpayer_banner/dismiss');